import React from "react";

import SubmitButton from "./SubmitButton";

export default () => {
  return <SubmitButton defaultText="Search" submittingText="Searching..." />;
};
